import Axios from 'axios';

import { CONFIGS } from '../commons/constants/constants';

export const getFlareConfig = (): Promise<{ data: Record<any, any> }> => {
  return Axios.get(CONFIGS.FLARE);
};
